import { ROUTE_CONFIG } from "@/routes/config";

import { listIdsParam } from "../../components/ListScopeFilter/listScope";

import { Tabs, TAB_PARAM } from "./outboxTabs";
import { OutboxStatusTab, STATUS_TAB_PARAM } from "./outboxStatusTabs";
import { allSendersItem } from "./outboxSenders";

export interface OutboxCampaignLinkInput {
	listId: number;
	/** Shown on the Outbox's list filter chip; a list without a name gets an empty title. */
	listName?: string | null;
	/** The campaign uuid, the value the Outbox's `campaignIds` filter matches. */
	campaignUuid: string;
	/** The status tab the Outbox opens on. */
	tab: OutboxStatusTab;
}

/**
 * The Outbox, opened on one status tab and narrowed to one campaign of one list (PREC-4291). Every
 * param is one `useOutboxUrlState` reads:
 * - `listIds` is a JSON array of `{ id, title }` list items, not bare ids, and the campaign
 *   filter's options are loaded for the selected lists, so the list travels with the campaign;
 * - `campaignIds` is a JSON array of campaign uuids;
 * - `senders` is "All", the item the Outbox writes for a viewer who sends nothing
 *   (`allSendersItem`). Without it the Outbox narrows to the viewer's own leads whenever the viewer
 *   is a sender, and a campaign sent by a colleague would open empty.
 *
 * The one place this URL is written, so the global Campaigns page can link the same way (PREC-4596).
 */
export const buildOutboxCampaignHref = ({
	listId,
	listName,
	campaignUuid,
	tab,
}: OutboxCampaignLinkInput): string => {
	const params = new URLSearchParams();

	params.set(TAB_PARAM, Tabs.CAMPAIGN);
	params.set(STATUS_TAB_PARAM, tab);
	params.set("listIds", listIdsParam(listId, listName));
	params.set("campaignIds", JSON.stringify([campaignUuid]));
	params.set("senders", JSON.stringify([allSendersItem()]));

	return `${ROUTE_CONFIG.MESSAGE_CENTER_OUTBOX}?${params.toString()}`;
};
